import React from "react";
import { Box, Container } from "@mui/material";
import { COLORS } from "../../constants";
import { LOGO_URL } from "./constants";
import MechanicalBackground from "./MechanicalBackground";

const ApplicationLayout = ({ isMobile, children }) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: COLORS.themeYellow,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Minimal header */}
      <Box
        sx={{
          backgroundColor: COLORS.white,
          px: isMobile ? 3 : 5,
          boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
          position: "relative",
          zIndex: 2,
        }}
      >
        <Box
          component="img"
          src={LOGO_URL}
          alt="Argus Motor Company"
          sx={{ height: 77 }}
        />
      </Box>

      <MechanicalBackground />

      <Container
        maxWidth="lg"
        sx={{ py: isMobile ? 4 : 7, position: "relative", zIndex: 1 }}
      >
        <Box
          sx={{
            backgroundColor: COLORS.white,
            borderRadius: "4px",
            boxShadow: "0 8px 40px rgba(0,0,0,0.14)",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            minHeight: 600,
            overflow: "hidden",
          }}
        >
          {children}
        </Box>
      </Container>
    </Box>
  );
};

export default ApplicationLayout;
